import ClientData from "@/common/client_data"
import env from "@/common/env"
import { isBlank, pushToDataLayer } from "@/common/util"

export const vatEntry = (country: string, company?: string) => {
  if (company) {
    return !isBlank(company) && ClientData.vatEnabledCountries?.includes(country)
  } else {
    return ClientData.vatEnabledCountries?.includes(country)
  }
}

export const einvoiceEntry = (business: boolean, country: string) => {
  return business && ["DK", "NO", "SE", "FI"].includes(country) && env.locale.endsWith(country)
}

export const shouldValidateVat = (company?: string, country?: string) => {
  return company && country && ClientData.vatEnabledCountries?.includes(country)
}

// const registeredFails: string[] = []

const trackedFields: Record<string, string> = {
  ".name": "Delivery full name",
  ".invoiceName": "Full name",
  ".vatId": "VAT",
  ".company": "Company",
  ".invoiceCompany": "Company",
  ".phone1": "Phone",
  ".email": "Email",
  ".tempPassword": "Password",
  ".firstName": "First name",
  ".deliveryFirstName": "Delivery first name",
  ".lastName": "Last name",
  ".deliveryLastName": "Delivery last name",
  ".street": "Street",
  ".invoiceStreet": "Street",
  ".houseNumber": "House nr",
  ".invoiceHouseNumber": "House nr",
  ".deliveryHouseNumber": "Delivery house nr",
  ".deliveryStreet": "Delivery street",
  ".zipcode": "Zip",
  ".invoiceZipcode": "Zip",
  ".deliveryZipcode": "Delivery zip",
  ".state": "State",
  ".invoiceState": "State",
  ".city": "City",
  ".invoiceCity": "City",
  ".deliveryCity": "Delivery city",
  ".country": "Country",
  ".invoiceCountry": "Country",
  ".deliveryCountry": "Delivery country",
}

const validatedFieldName = (field: string) => {
  if (field === "email") {
    return "Forgot Email"
  }

  if (field === "login" || field === "email") {
    return "Login Email"
  }

  if (field === "password") {
    return "Login Password"
  }

  for (const key in trackedFields) {
    if (Object.prototype.hasOwnProperty.call(trackedFields, key)) {
      if (field.endsWith(key)) {
        return trackedFields[key]
      }
    }
  }

  return field
}

export const registerValidationFail = (field: string, type: string) => {
  type = type === "required" ? type : "format"
  const name = validatedFieldName(field)

  // if (registeredFails.includes(`${name}=${type}`)) {
  //   return
  // }

  // registeredFails.push(`${name}=${type}`)
  pushToDataLayer({ event: "checkout-error", validationField: name, validationType: type })
}

export const registerImageSearch = (search: string) => {
  pushToDataLayer({ event: "image-search", imageSearchQuery: search })
}
